var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vx-card',{attrs:{"title":"Reversal Invoice"}},[_c('vs-tabs',[_c('vs-tab',{attrs:{"label":"Open"}},[_c('open')],1),_c('vs-tab',{attrs:{"label":"Approved"}},[_c('div',{staticClass:"tab-text"},[_c('approved')],1)]),_c('vs-tab',{attrs:{"label":"Rejected"}},[_c('div',{staticClass:"tab-text"},[_c('rejected')],1)])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }